import React from "react"
import {ManagedSolutionsCard} from "../../../containers/ManagedSolutionsCard/ManagedSolutionsCard"
import {ProgramPerformanceItemCard} from "../../ProgramPerformanceItemCard/ProgramPerformanceItemCard"
import {ProgramPerformanceItem} from "../../ProgramPerformanceItemCard/types"
import classNames from "classnames"

interface ProgramPerformanceCardProps {
	items: ProgramPerformanceItem[]
	className?: string
}

export function ProgramPerformanceCard({items, className}: ProgramPerformanceCardProps) {
	return (
		<ManagedSolutionsCard
			title="Your Program Performance"
			className={classNames("program-performance-card", className)}
		>
			<div className="columns is-multiline">
				{items.map((item, index) => (
					<div key={index} className="column is-one-third">
						<ProgramPerformanceItemCard {...item} />
					</div>
				))}
			</div>
		</ManagedSolutionsCard>
	)
}
